import { useEffect, useState } from "react";

const ImageSlider = (props) => {

    const [index, setIndex] = useState(0)

    const {
        imageArray,
        speed, // slow, normal, fast
        size, // small, normal, big
        animated // true, false
    } = props

    const speedMap = {
        slow: 4500,
        normal: 3000,
        fast: 1500,
    }
    
    const sizeMap = {
        small: "small-slider-image",
        normal: "normal-slider-image",
        big: "big-slider-image",
    }

    useEffect(() => {
        if (!imageArray) return
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % imageArray.length)
        }, speedMap[speed || "normal"]);
        return () => clearInterval(interval);
    }, [imageArray.length]);

    return (
        <>
            <img loading="lazy" alt="Imagen" src={imageArray[index]} className={sizeMap[size || "normal"] + ((animated || false) ? " image-rotate":"") } ></img>
        </>
    )

}

export default ImageSlider